import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDisabilityService } from './../../Services/disabilityService'

export const reducerName = 'disability';

const initialState = {
  request: false,
  error: null,
  data: null
};

export const getDisability = createAsyncThunk(
  'disability/get',
  async (a, { rejectWithValue }) => {
    try {
      
      const response = await getDisabilityService();

      return {
        data: response
      };
    } catch (error) {
      return rejectWithValue({
        error: error.message
      })
    }
  }
);


export const disabilityReducer = createSlice({
  name: reducerName,
  initialState,
  extraReducers: (builder) => {

    builder.addCase(getDisability.fulfilled, (state, action) => {
      state.data = action.payload?.data;
      state.request = false;
    })

    builder.addCase(getDisability.rejected, (state, action) => {
      state.error = action.payload.error;
      state.request = false;
      state.data = null;
    })

    builder.addCase(getDisability.pending, (state) => {
      state.request = true;
      state.error = null;
      state.data = null;
    })
  }
});

export default disabilityReducer.reducer;
